/* Compre Junto — Casa Buda
 * Lógica de selección de variantes, checkboxes y add-to-cart múltiple.
 */
(function () {
  'use strict';
 
  const root = document.querySelector('[data-compre-junto]');
  if (!root) return;
 
  const cards   = Array.from(root.querySelectorAll('[data-cj-card]'));
  const totalEl = root.querySelector('[data-cj-total]');
  const btn     = root.querySelector('[data-cj-add]');
  const status  = root.querySelector('[data-cj-status]');
 
  // -------- Formateo de moneda (CLP: sin decimales, punto como separador de miles) --------
  function formatMoney(cents) {
    const n = Math.round(cents / 100);
    return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
 
  // -------- Inicialización por tarjeta --------
  cards.forEach(card => {
    const variantBtns = card.querySelectorAll('[data-cj-variant-id]');
 
    // Caso 1: input hidden (producto con una sola variante)
    if (variantBtns.length === 1 && variantBtns[0].tagName === 'INPUT') {
      card.dataset.cjSelectedVariant = variantBtns[0].dataset.cjVariantId;
      card.dataset.cjSelectedPrice   = variantBtns[0].dataset.cjVariantPrice || '0';
    }
 
    // Caso 2: botones de talla (varias variantes)
    if (variantBtns.length > 1) {
      // Selección inicial: primera disponible
      const firstAvailable = Array.from(variantBtns).find(
        b => b.dataset.cjAvailable === 'true'
      );
      if (firstAvailable) {
        selectVariant(card, firstAvailable);
      }
 
      variantBtns.forEach(b => {
        b.addEventListener('click', () => {
          if (b.dataset.cjAvailable !== 'true') return;
          selectVariant(card, b);
          refresh();
        });
      });
    }
 
    // Checkbox
    const cb = card.querySelector('[data-cj-checkbox]');
    if (cb) cb.addEventListener('change', refresh);
  });
 
  function selectVariant(card, btnEl) {
    card.querySelectorAll('[data-cj-variant-id]').forEach(x => {
      x.classList.remove('is-selected');
      if (x.setAttribute) x.setAttribute('aria-checked', 'false');
    });
    btnEl.classList.add('is-selected');
    btnEl.setAttribute('aria-checked', 'true');
    card.dataset.cjSelectedVariant = btnEl.dataset.cjVariantId;
    card.dataset.cjSelectedPrice   = btnEl.dataset.cjVariantPrice;
 
    // Actualizar precio mostrado en la tarjeta
    const priceEl = card.querySelector('[data-cj-price]');
    if (priceEl) {
      priceEl.textContent = formatMoney(parseInt(btnEl.dataset.cjVariantPrice, 10));
    }
  }
 
  function getSelectedCards() {
    return cards.filter(card => {
      const cb = card.querySelector('[data-cj-checkbox]');
      return cb && cb.checked;
    });
  }
 
  function refresh() {
    const selected = getSelectedCards();
    let total = 0;
    let allValid = selected.length > 0;
 
    selected.forEach(card => {
      const variantId = card.dataset.cjSelectedVariant;
      const price = parseInt(card.dataset.cjSelectedPrice || '0', 10);
      total += price;
      if (!variantId) allValid = false;
    });
 
    if (totalEl) totalEl.textContent = formatMoney(total);
    if (btn)     btn.disabled = !allValid;
    if (status)  { status.hidden = true; status.textContent = ''; }
  }
 
  // -------- Add to cart --------
  btn.addEventListener('click', async () => {
    const selected = getSelectedCards();
    const items = selected
      .map(card => ({
        id: parseInt(card.dataset.cjSelectedVariant, 10),
        quantity: 1
      }))
      .filter(i => !!i.id);
 
    if (items.length === 0) return;
 
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'AGREGANDO...';
 
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });
 
      if (!res.ok) {
        const errBody = await res.json().catch(() => ({}));
        throw new Error(errBody.description || 'Error al agregar al carrito');
      }
 
      // Avisar al theme para que abra/refresque el cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      // Algunos themes (Dawn): publish event
      if (window.PUB_SUB_EVENTS && window.publish) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'compre-junto' });
      }
 
      btn.textContent = 'AGREGADO ✓';
      setTimeout(() => {
        btn.textContent = originalText;
        refresh();
      }, 1800);
    } catch (err) {
      console.error('[Compre Junto]', err);
      btn.textContent = originalText;
      if (status) {
        status.hidden = false;
        status.textContent = err.message || 'No fue posible agregar los productos. Inténtalo de nuevo.';
      }
      btn.disabled = false;
    }
  });
 
  refresh();
})();
 